// /auth/callback: Keycloak returns here. AuthProvider completes the sign-in before the app renders, so by the
// time this route shows, the user is signed in; send them on to where they were going (Plan by default).
import { Navigate } from 'react-router';
import { takeReturnTo } from './returnTo';

export function SignInCallback() {
  return <Navigate to={takeReturnTo()} replace />;
}
